<script lang="ts" setup>
import type { SbReversedPostCard } from '@/types'
interface Props {
  blok: SbReversedPostCard
}
const props = defineProps<Props>()

const backgroundColorLeft = computed(() => {
  return {
    backgroundColor: props.blok.bg_color_left?.value,
  }
})

const backgroundColorRight = computed(() => {
  return {
    backgroundColor: props.blok.bg_color_right?.value,
  }
})
</script>

<template>
  <div class="reversed-post-card">
    <div class="reversed-post-card__left" :style="backgroundColorLeft">
      <StoryblokComponent
        v-editable="blok"
        v-for="childBlok in blok.content_left"
        :key="childBlok._uid"
        :blok="childBlok"
      />
    </div>
    <div class="reversed-post-card__right" :style="backgroundColorRight">
      <StoryblokComponent
        v-editable="blok"
        v-for="childBlok in blok.content_right"
        :key="childBlok._uid"
        :blok="childBlok"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.reversed-post-card {
  display: flex;
  flex-direction: column-reverse;
  border-radius: var(--border-radius-extra-large);
  overflow: hidden;
  @media (min-width: $breakpoint-lg) {
    flex-direction: row;
    min-height: 400px;
  }
  &__left {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 48px;

    @media (min-width: $breakpoint-lg) {
      padding: 80px 80px 56px 64px;
    }
  }
  &__right {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    @media (min-width: $breakpoint-lg) {
      min-width: 427px;
    }
  }
}
</style>
